import { Text } from '@fluentui/react-components';
import { isEmpty } from 'es-toolkit/compat';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { AwardJudging } from '../../../models';
import { AwardJudgingBox } from '../award-judging-box/AwardJudgingBox';
import './AwardJudgingBoxSection.scss';
import { FlexBox } from '../flex-box';
import { getCountryAwardJudgingKey } from './country-award-judging-key';

interface AwardJudgingBoxSectionProps {
  awardJudgings: AwardJudging[];
  countryAwardJudgings: AwardJudging[];
  awardAlertMessages: Map<number, string>;
  countryAwardAlertMessages: Map<string, string>;
  handleAwardJudgingButtonClicked(awardJudging: AwardJudging): void;
  handleCountryAwardJudgingButtonClicked(awardJudging: AwardJudging): void;
}

const AwardJudgingBoxSectionImpl: React.FC<AwardJudgingBoxSectionProps> = (props) => {
  const {
    awardJudgings,
    countryAwardJudgings,
    awardAlertMessages,
    countryAwardAlertMessages,
    handleAwardJudgingButtonClicked,
    handleCountryAwardJudgingButtonClicked
  } = props;

  const awardJudgingBox = (
    title: string,
    judgings: AwardJudging[],
    onJudgingButtonClicked: (awardJudging: AwardJudging) => void,
  ): React.ReactNode => {
    if (isEmpty(judgings)) return null;

    return (
      <div className='award-judging-box-section'>
        <Text
          block
          as='h3'
          weight='semibold'
          size={500}
        >
          {title}
        </Text>
        <FlexBox
          wrap
          className='award-judging-box-section__wrapper'
        >
          {
            judgings.map((judging) => {
              return (
                <AwardJudgingBox
                  key={`${judging.awardId}-${judging.countryId ?? ''}`}
                  awardJudging={judging}
                  alertMessage={judging.countryId
                    ? countryAwardAlertMessages.get(getCountryAwardJudgingKey(judging.awardId, judging.countryId))
                    : awardAlertMessages.get(judging.awardId)}
                  onJudgingButtonClicked={() => onJudgingButtonClicked(judging)}
                />
              );
            })
          }
        </FlexBox>
      </div>
    );
  }

  return (
    <>
      {awardJudgingBox('Award to judge', awardJudgings, handleAwardJudgingButtonClicked)}
      {awardJudgingBox('Country Award to judge', countryAwardJudgings, handleCountryAwardJudgingButtonClicked)}
    </>
  );
}

export const AwardJudgingBoxSection = observer(AwardJudgingBoxSectionImpl);
